/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import React from 'react';
import { Box, Typography } from '@material-ui/core';
import useStyles from './ErrorCard.styles';

interface ErrorCardProps {
  title?: React.ReactNode;
  description?: React.ReactNode;
  image?: React.ReactNode;
  actions?: React.ReactNode;
  children?: React.ReactNode;
  testId: string;
}

function ErrorCard(props: ErrorCardProps) {
  const { title, description, image, actions, children, testId } = props;
  const classes = useStyles();
  return (
    <Box className={classes.errorCard} data-cyid={`${testId}-error-card`}>
      <Box className={classes.errorCardContent}>
        {image && <Box className={classes.errorCardImage}>{image}</Box>}
        {title && (
          <Box className={classes.errorCardTitle}>
            <Typography variant="h2">{title}</Typography>
          </Box>
        )}
        {description && (
          <Box className={classes.errorCardDescription}>
            <Typography variant="body1" color="secondary">
              {description}
            </Typography>
          </Box>
        )}

        {children && (
          <Box className={classes.errorCardChildren}>{children}</Box>
        )}
        {actions && <Box className={classes.errorCardAction}>{actions}</Box>}
      </Box>
    </Box>
  );
}

export default ErrorCard;
